import React, {useEffect, useState} from 'react'

import {Col, Container, Row} from 'react-bootstrap'

import KurzyLayout from './KurzyLayout'
import {useContentWrapper} from '../common/ContentWrapperProvider'
import {StyledInfoPageHeaderWrapper} from '../common/styledComponents'
import axios, {SERVER_URL} from '../service/axiosClient'
import {OrderItemCategory} from '../types/OrderItemCategory'
import {OrderItemDtoUI} from '../types/OrderItemDto'


function LektoriPage() {
    const contentWrapper = useContentWrapper()
    const [products, setProducts] = useState<OrderItemDtoUI[]>([])

    useEffect(() => {
        contentWrapper.setNoBootstrapColumns(true)


        axios.get('/order-item/' + OrderItemCategory.LEKTORI, {}).then(response => {
            console.log('mame data', response.data)

            setProducts(response.data || [])
        }).catch(error => {
            console.log('error', error)
        })

        return () => {
            contentWrapper.setNoBootstrapColumns(false)
        }
    }, [])

    return (
        <KurzyLayout>
            <StyledInfoPageHeaderWrapper>
                <Container>
                    <Row>
                        <Col>
                            <h1 className={'font-vollkorn fs-55 color-pink-primary'}>Lektori</h1>
                        </Col>
                    </Row>
                </Container>

            </StyledInfoPageHeaderWrapper>
            <Container>
                <Row>
                    <Col>
                        <div className="kurzy-container">
                            {products.map((item, index) => {
                                console.log('helo there', item)
                                return <div key={index} className="kurzy-item lektor flex-column">
                                    <div className="d-flex gap-2 mobile-flex-column">
                                        <div className="image-left">
                                            <img src={`${SERVER_URL}/storage/${item.image}`} alt=""/>
                                        </div>
                                        <div className="content-right text-center">
                                            <h3 className={'font-vollkorn color-pink-primary mb-2 primary-text-color'}>{item.name}</h3>
                                            <div dangerouslySetInnerHTML={{__html: item.agenda}}/>
                                            <div className={'d-flex flex-row gap-2 justify-content-center mt-3'}>
                                                {item.web && <a href={item.web} target="_blank"
                                                                rel="noreferrer" className="nav-link"><i
                                                    className="bi bi-browser-chrome "></i></a>}
                                                {item.linked_in && <a href={item.linked_in} target="_blank"
                                                                      rel="noreferrer" className="nav-link"><i
                                                    className="bi bi-linkedin "></i></a>}
                                                {item.facebook && <a href={item.facebook}
                                                                     target="_blank" rel="noreferrer"
                                                                     className="nav-link"><i
                                                    className="bi bi-facebook "></i></a>}
                                                {item.instagram && <a href={item.instagram}
                                                                      target="_blank" rel="noreferrer"
                                                                      className="nav-link"><i
                                                    className="bi bi-instagram "></i></a>}
                                            </div>
                                            <div className={'mt-2 p-2'}><i className={'primary-text-color font-shantell-non-cursive'}>{item.quote}</i></div>
                                        </div>
                                    </div>
                                    <div className={'mt-3'} dangerouslySetInnerHTML={{__html: item.description}}/>

                                </div>
                            })}


                        </div>
                    </Col>
                </Row>
            </Container>
        </KurzyLayout>
    )
}

export default LektoriPage
